import { Tag, Text, theme } from '@/components';
import { CheckCircleFilled, CheckCircleOutlined } from '@ant-design/icons';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  resolved: boolean;
};

export const CommentResolvedBadge: FC<Props> = ({ resolved }) => {
  const { t } = useTranslation();
  const { token } = theme.useToken();

  return (
    <Tag
      style={{
        width: 78,
        height: 26,
        borderColor: token.colorSuccess,
        borderRadius: 13,
        color: token.colorSuccess,
        backgroundColor: resolved ? token.colorSuccessBg : token.colorBgBase,
      }}
      icon={
        resolved ? (
          <CheckCircleFilled color={token.colorPrimary} />
        ) : (
          <CheckCircleOutlined color={token.colorPrimary} />
        )
      }
    >
      <Text
        text={resolved ? t('resolved') : t('unresolved')}
        weight="regular"
      />
    </Tag>
  );
};
